[
  {
    "audience": "Arab",
    "name": "Asia Bast",
    "engagementRate": 4.92,
    "followers": 2200000,
    "instagramLink": "https://www.instagram.com/asia_bast"
  },
  {
    "audience": "Kurd",
    "name": "Sazan Amin",
    "engagementRate": 0.25,
    "followers": 1000000,
    "instagramLink": "https://www.instagram.com/sazanamin_"
  },
  {
    "audience": "Arab",
    "name": "Ala Alibrahimi",
    "engagementRate": 5.18,
    "followers": 102000,
    "instagramLink": "https://www.instagram.com/ali.haitham"
  },
  {
    "audience": "Arab",
    "name": "Ali Najm",
    "engagementRate": 6.33,
    "followers": 500000,
    "instagramLink": "https://www.instagram.com/alinajm3"
  },
  {
    "audience": "Arab",
    "name": "Ali Smsm",
    "engagementRate": 0.24,
    "followers": 399000,
    "instagramLink": "https://www.instagram.com/ali_jabar_h"
  },
  {
    "audience": "Kurd",
    "name": "Aram Faruq",
    "engagementRate": 0.04,
    "followers": 50100,
    "instagramLink": "https://www.instagram.com/aram._.faruq"
  },
  {
    "audience": "Kurd",
    "name": "Arman Ameer",
    "engagementRate": 2.38,
    "followers": 539000,
    "instagramLink": "https://www.instagram.com/arman__ameer"
  },
  {
    "audience": "Arab",
    "name": "Aseel yasin",
    "engagementRate": 0.44,
    "followers": 903000,
    "instagramLink": "https://www.instagram.com/aseel.yaseeen"
  },
  {
    "audience": "Kurd",
    "name": "Avrın Hemo",
    "engagementRate": 2.29,
    "followers": 246000,
    "instagramLink": "https://www.instagram.com/avrinhemo"
  },
  {
    "audience": "Kurd",
    "name": "Awat Abdullah",
    "engagementRate": 5.64,
    "followers": 175000,
    "instagramLink": "https://www.instagram.com/awat91"
  },
  {
    "audience": "Arab",
    "name": "Aya Basit",
    "engagementRate": 9.78,
    "followers": 708000,
    "instagramLink": "https://www.instagram.com/aya.bast"
  },
  {
    "audience": "Kurd",
    "name": "Azeez Omed",
    "engagementRate": 0.19,
    "followers": 364000,
    "instagramLink": "https://www.instagram.com/azeez.omed"
  },
  {
    "audience": "Kurd",
    "name": "Azhin Azad",
    "engagementRate": 1.94,
    "followers": 317000,
    "instagramLink": "https://www.instagram.com/ajin_azad"
  },
  {
    "audience": "Kurd",
    "name": "Banu Dlshad",
    "engagementRate": 3.07,
    "followers": 1300000,
    "instagramLink": "https://www.instagram.com/banudlshadd"
  },
  {
    "audience": "Kurd",
    "name": "Bnar Pshko",
    "engagementRate": 3.07,
    "followers": 343000,
    "instagramLink": "https://www.instagram.com/bnar.pshko"
  },
  {
    "audience": "Arab",
    "name": "Chef Aya Alfatlawy",
    "engagementRate": 0.81,
    "followers": 2100000,
    "instagramLink": "https://www.instagram.com/chef.aya.khalid"
  },
  {
    "audience": "Kurd",
    "name": "Chewaz Aso",
    "engagementRate": 0.17,
    "followers": 1000000,
    "instagramLink": "https://www.instagram.com/chewazaso.official"
  },
  {
    "audience": "Kurd",
    "name": "Chopy hasip",
    "engagementRate": 0.73,
    "followers": 119000,
    "instagramLink": "https://www.instagram.com/chopy_w_drusty"
  },
  {
    "audience": "Kurd",
    "name": "Dalya Ibrahim",
    "engagementRate": 4.87,
    "followers": 117000,
    "instagramLink": "https://www.instagram.com/dalya_ibrahim_"
  },
  {
    "audience": "Kurd",
    "name": "Darya Anwar",
    "engagementRate": 2.72,
    "followers": 160000,
    "instagramLink": "https://www.instagram.com/with.darya"
  },
  {
    "audience": "Kurd",
    "name": "Didam Azad",
    "engagementRate": 4.99,
    "followers": 83100,
    "instagramLink": "https://www.instagram.com/didam.azad"
  },
  {
    "audience": "Arab",
    "name": "Dr Meenaz",
    "engagementRate": 1.5,
    "followers": 106000,
    "instagramLink": "https://www.instagram.com/dr_meenaz"
  },
  {
    "audience": "Arab",
    "name": "Dunia Yasir",
    "engagementRate": 2.42,
    "followers": 1300000,
    "instagramLink": "https://www.instagram.com/dunya.yasir"
  },
  {
    "audience": "Arab",
    "name": "Esraa Salam",
    "engagementRate": 4.81,
    "followers": 685000,
    "instagramLink": "https://www.instagram.com/esraalsalam"
  },
  {
    "audience": "Arab",
    "name": "Essa Ahmed",
    "engagementRate": 3.6,
    "followers": 717000,
    "instagramLink": "https://www.instagram.com/esaa_xiq"
  },
  {
    "audience": "Arab",
    "name": "Fatam Awad",
    "engagementRate": 17.79,
    "followers": 61200,
    "instagramLink": "https://www.instagram.com/fatam.84"
  },
  {
    "audience": "Arab",
    "name": "Faten Alhatab",
    "engagementRate": 1.53,
    "followers": 1000000,
    "instagramLink": "https://www.instagram.com/faten_alhatab"
  },
  {
    "audience": "Arab",
    "name": "Fatima Sahrawy",
    "engagementRate": 0.77,
    "followers": 168000,
    "instagramLink": "https://www.instagram.com/fatima.sahrawy"
  },
  {
    "audience": "Kurd",
    "name": "Ghufran Ahmed",
    "engagementRate": 1.03,
    "followers": 108000,
    "instagramLink": "https://www.instagram.com/ghufran.ahmedd"
  },
  {
    "audience": "Kurd",
    "name": "Gulzar",
    "engagementRate": 0.42,
    "followers": 143000,
    "instagramLink": "https://www.instagram.com/gullzar.mu"
  },
  {
    "audience": "Kurd",
    "name": "Haji Jader",
    "engagementRate": 0.13,
    "followers": 640000,
    "instagramLink": "https://www.instagram.com/haji.jadr.official"
  },
  {
    "audience": "Kurd",
    "name": "Hama Shah",
    "engagementRate": 0.92,
    "followers": 424000,
    "instagramLink": "https://www.instagram.com/hamasha.official"
  },
  {
    "audience": "Kurd",
    "name": "Hana Saber",
    "engagementRate": 2.36,
    "followers": 103000,
    "instagramLink": "https://www.instagram.com/hanasaberofficial"
  },
  {
    "audience": "Kurd",
    "name": "Helyan Shirzad",
    "engagementRate": 1.84,
    "followers": 104000,
    "instagramLink": "https://www.instagram.com/helyshirzad"
  },
  {
    "audience": "Arab",
    "name": "Hind Nizar",
    "engagementRate": 0.26,
    "followers": 6500000,
    "instagramLink": "https://www.instagram.com/hindnizar"
  },
  {
    "audience": "Kurd",
    "name": "Ivana Kawa",
    "engagementRate": 0.66,
    "followers": 539000,
    "instagramLink": "https://www.instagram.com/ivana__kawa"
  },
  {
    "audience": "Kurd",
    "name": "Jay Kurdi",
    "engagementRate": 1.96,
    "followers": 326000,
    "instagramLink": "https://www.instagram.com/jaykurdii"
  },
  {
    "audience": "Kurd",
    "name": "Jehan Hashim",
    "engagementRate": 0.62,
    "followers": 15500000,
    "instagramLink": "https://www.instagram.com/jehan.hashim"
  },
  {
    "audience": "Kurd",
    "name": "Kaylan",
    "engagementRate": 0.71,
    "followers": 517000,
    "instagramLink": "https://www.instagram.com/keylan.official"
  },
  {
    "audience": "Kurd",
    "name": "Khandool",
    "engagementRate": 1.9,
    "followers": 92700,
    "instagramLink": "https://www.instagram.com/khandool"
  },
  {
    "audience": "Kurd",
    "name": "Laya Azami",
    "engagementRate": 1.66,
    "followers": 86000,
    "instagramLink": "https://www.instagram.com/liiana_official"
  },
  {
    "audience": "Kurd",
    "name": "Marwa Sam",
    "engagementRate": 0.61,
    "followers": 371000,
    "instagramLink": "https://www.instagram.com/marwa._sam"
  },
  {
    "audience": "Arab",
    "name": "Mayada Saad",
    "engagementRate": 1.96,
    "followers": 542000,
    "instagramLink": "https://www.instagram.com/mayadasaad"
  },
  {
    "audience": "Arab",
    "name": "Masa Sam",
    "engagementRate": 0.14,
    "followers": 3000000,
    "instagramLink": "https://www.instagram.com/masa_sam"
  },
  {
    "audience": "Arab",
    "name": "Maythm Muthana",
    "engagementRate": 6.56,
    "followers": 1000000,
    "instagramLink": "https://www.instagram.com/mayytham"
  },
  {
    "audience": "Arab",
    "name": "Mohammed Zilzal",
    "engagementRate": 1.61,
    "followers": 413000,
    "instagramLink": "https://www.instagram.com/mohammed_zilzal"
  },
  {
    "audience": "Arab",
    "name": "Mustafa Ibrahim",
    "engagementRate": 1.98,
    "followers": 640000,
    "instagramLink": "https://www.instagram.com/mustafa_ibrahm"
  },
  {
    "audience": "Arab",
    "name": "Mustafa Maysar",
    "engagementRate": 13.49,
    "followers": 410000,
    "instagramLink": "https://www.instagram.com/mustafa_myasar9_4"
  },
  {
    "audience": "Kurd",
    "name": "Nada",
    "engagementRate": 0.82,
    "followers": 127000,
    "instagramLink": "https://www.instagram.com/nada.nawzhin"
  },
  {
    "audience": "Kurd",
    "name": "Nasy",
    "engagementRate": 3.43,
    "followers": 79500,
    "instagramLink": "https://www.instagram.com/n_a_s_y__"
  },
  {
    "audience": "Kurd",
    "name": "Noor Life style",
    "engagementRate": 0.93,
    "followers": 450000,
    "instagramLink": "https://www.instagram.com/noorlifestyle_"
  },
  {
    "audience": "Kurd",
    "name": "Nuha Bahadeen",
    "engagementRate": 1.04,
    "followers": 111000,
    "instagramLink": "https://www.instagram.com/nuhabahadeen"
  },
  {
    "audience": "Kurd",
    "name": "Parwin Sharaf",
    "engagementRate": 4.02,
    "followers": 123000,
    "instagramLink": "https://www.instagram.com/parwin_sharafxan"
  },
  {
    "audience": "Arab",
    "name": "Rafal Sali",
    "engagementRate": 3.8,
    "followers": 170000,
    "instagramLink": "https://www.instagram.com/rafalsali"
  },
  {
    "audience": "Arab",
    "name": "Rawan Hani",
    "engagementRate": 11.89,
    "followers": 507000,
    "instagramLink": "https://www.instagram.com/dr.rawanh"
  },
  {
    "audience": "Arab",
    "name": "Rusul adel",
    "engagementRate": 10.36,
    "followers": 299000,
    "instagramLink": "https://www.instagram.com/russuladell"
  },
  {
    "audience": "Arab",
    "name": "Safa",
    "engagementRate": 3.45,
    "followers": 1000000,
    "instagramLink": "https://www.instagram.com/safa.m_0"
  },
  {
    "audience": "Kurd",
    "name": "Sakar",
    "engagementRate": 1.85,
    "followers": 538000,
    "instagramLink": "https://www.instagram.com/sakar.officiall"
  },
  {
    "audience": "Arab",
    "name": "Sara Alhialy",
    "engagementRate": 1.65,
    "followers": 274000,
    "instagramLink": "https://www.instagram.com/sarah.alhialy"
  },
  {
    "audience": "Kurd",
    "name": "Sara Nadeem",
    "engagementRate": 3.35,
    "followers": 1800000,
    "instagramLink": "https://www.instagram.com/sara_nadeem"
  },
  {
    "audience": "Arab",
    "name": "Sara Deniz",
    "engagementRate": 1.99,
    "followers": 314000,
    "instagramLink": "https://www.instagram.com/sarah.deniz1"
  },
  {
    "audience": "Arab",
    "name": "Sara Yousif",
    "engagementRate": 8.15,
    "followers": 518000,
    "instagramLink": "https://www.instagram.com/sarah.yousif96"
  },
  {
    "audience": "Arab",
    "name": "Sarah Alhialy",
    "engagementRate": 1.65,
    "followers": 274000,
    "instagramLink": "https://www.instagram.com/sarah.alhialy"
  },
  {
    "audience": "Arab",
    "name": "Sarah alrubahe",
    "engagementRate": 1.45,
    "followers": 473000,
    "instagramLink": "https://www.instagram.com/sarah_alruba3e"
  },
  {
    "audience": "Arab",
    "name": "Sarah Hassoun",
    "engagementRate": 1.74,
    "followers": 321000,
    "instagramLink": "https://www.instagram.com/sarah.hassoun"
  },
  {
    "audience": "Kurd",
    "name": "Saya Kamil",
    "engagementRate": 3.62,
    "followers": 76500,
    "instagramLink": "https://www.instagram.com/sayon.kamil"
  },
  {
    "audience": "Kurd",
    "name": "Saz Aso",
    "engagementRate": 1.27,
    "followers": 918000,
    "instagramLink": "https://www.instagram.com/sazaso"
  },
  {
    "audience": "Arab",
    "name": "Shadi Arabic",
    "engagementRate": 0.42,
    "followers": 757000,
    "instagramLink": "https://www.instagram.com/shadi_arabic"
  },
  {
    "audience": "Kurd",
    "name": "Shadi Sweet",
    "engagementRate": 6.33,
    "followers": 40100,
    "instagramLink": "https://www.instagram.com/shadi__sweet"
  },
  {
    "audience": "Arab",
    "name": "Shahad Alkhafaji",
    "engagementRate": 0.06,
    "followers": 999000,
    "instagramLink": "https://www.instagram.com/shahad_alkhafaji1311"
  },
  {
    "audience": "Arab",
    "name": "Shahad- Ay",
    "engagementRate": 2.16,
    "followers": 331000,
    "instagramLink": "https://www.instagram.com/shahadayad_y"
  },
  {
    "audience": "Arab",
    "name": "Shahad Salman",
    "engagementRate": 1.63,
    "followers": 404000,
    "instagramLink": "https://www.instagram.com/shahadsalmman"
  },
  {
    "audience": "Kurd",
    "name": "Shahi Hemo",
    "engagementRate": 1.14,
    "followers": 519000,
    "instagramLink": "https://www.instagram.com/shahihemo"
  },
  {
    "audience": "Arab",
    "name": "Shaima Qasim",
    "engagementRate": 0.66,
    "followers": 13300000,
    "instagramLink": "https://www.instagram.com/shimaa_qasim"
  },
  {
    "audience": "Arab",
    "name": "Shams Alkhazerjy",
    "engagementRate": 1.29,
    "followers": 775000,
    "instagramLink": "https://www.instagram.com/shamsoee"
  },
  {
    "audience": "Kurd",
    "name": "Shkova Farhad",
    "engagementRate": 0.89,
    "followers": 864000,
    "instagramLink": "https://www.instagram.com/shkovafarhad"
  },
  {
    "audience": "Kurd",
    "name": "Shnrwe Mustafa",
    "engagementRate": 0.94,
    "followers": 410000,
    "instagramLink": "https://www.instagram.com/shnrwe.mustafaa"
  },
  {
    "audience": "Kurd",
    "name": "Soma Ziyad",
    "engagementRate": 1.84,
    "followers": 37800,
    "instagramLink": "https://www.instagram.com/somaziyad"
  },
  {
    "audience": "Kurd",
    "name": "Soza Mohamed",
    "engagementRate": 2.05,
    "followers": 154000,
    "instagramLink": "https://www.instagram.com/sozamohamed"
  },
  {
    "audience": "Kurd",
    "name": "Sozan kemal",
    "engagementRate": 0.75,
    "followers": 1200000,
    "instagramLink": "https://www.instagram.com/sozankamalofficial"
  },
  {
    "audience": "Kurd",
    "name": "Sozyar Aras Abdurrahman",
    "engagementRate": 0.7,
    "followers": 113000,
    "instagramLink": "https://www.instagram.com/ladysozyar"
  },
  {
    "audience": "Arab",
    "name": "Suhair Salah",
    "engagementRate": 1.55,
    "followers": 3600000,
    "instagramLink": "https://www.instagram.com/souhair.salah"
  },
  {
    "audience": "Kurd",
    "name": "Sumaya Goran",
    "engagementRate": 0.42,
    "followers": 595000,
    "instagramLink": "https://www.instagram.com/sumaya_goran"
  },
  {
    "audience": "Kurd",
    "name": "Sumeyye",
    "engagementRate": 6.25,
    "followers": 230000,
    "instagramLink": "https://www.instagram.com/sumeyye.sm"
  },
  {
    "audience": "Kurd",
    "name": "Tamara Nadeem",
    "engagementRate": 2.55,
    "followers": 2200000,
    "instagramLink": "https://www.instagram.com/tamara.nadim"
  },
  {
    "audience": "Arab",
    "name": "Tamila Sinan",
    "engagementRate": 1.5,
    "followers": 2800000,
    "instagramLink": "https://www.instagram.com/tamila.sinan"
  },
  {
    "audience": "Arab",
    "name": "Tara Abdulbakri",
    "engagementRate": 3.1,
    "followers": 520000,
    "instagramLink": "https://www.instagram.com/tara.albakri"
  },
  {
    "audience": "Kurd",
    "name": "Van Soran",
    "engagementRate": 2.52,
    "followers": 36900,
    "instagramLink": "https://www.instagram.com/vansorann"
  },
  {
    "audience": "Arab",
    "name": "Walaa Ismail",
    "engagementRate": 0.62,
    "followers": 356000,
    "instagramLink": "https://www.instagram.com/walaa.interiors"
  },
  {
    "audience": "Kurd",
    "name": "Warvin Essa",
    "engagementRate": 3.45,
    "followers": 140000,
    "instagramLink": "https://www.instagram.com/warvin_essa"
  },
  {
    "audience": "Arab",
    "name": "Welyan Albaiaty",
    "engagementRate": 0.49,
    "followers": 7000000,
    "instagramLink": "https://www.instagram.com/welyanalbaiaty94"
  },
  {
    "audience": "Kurd",
    "name": "Xwani Shadi",
    "engagementRate": 0.49,
    "followers": 1000000,
    "instagramLink": "https://www.instagram.com/xwani_shadi"
  },
  {
    "audience": "Kurd",
    "name": "Yalda Mohammed",
    "engagementRate": 10.47,
    "followers": 33300,
    "instagramLink": "https://www.instagram.com/yalda_mohammed"
  },
  {
    "audience": "Arab",
    "name": "Zahraa Sami",
    "engagementRate": 3.35,
    "followers": 1300000,
    "instagramLink": "https://www.instagram.com/zahraa.sami"
  }
]